import { render, staticRenderFns } from "./BaseusOrders.vue?vue&type=template&id=ce209596&"
import script from "./BaseusOrders.vue?vue&type=script&lang=js&"
export * from "./BaseusOrders.vue?vue&type=script&lang=js&"
import style0 from "./BaseusOrders.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BaseusOrders.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports